module.exports = __webpack_public_path__ + "img/home-marketegg-1.4c923e5c.gif";